import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';


export class RomReviewView extends Component {

	render() {
		const {  reasonfortheRomReview, romExpertName, soMonitor, fieldPhaseStartDate } = this.props;
		return (
			<Card>
				<CardHeader title="Rom Review - Key Information" className='romis-card-header' />
				<CardContent>
					<TextField
						label="Reason for the ROM Review:"
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}
						value={reasonfortheRomReview}

					/>

					<TextField
						label="ROM Expert(s) Name(s) :"
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}
						value={romExpertName}

					/>
					<TextField
						label="CO Monitor :"
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}
						value={soMonitor}


					/>


					<TextField
						label="Field Phase Start Date:"
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}
						value={fieldPhaseStartDate}

					/>




				</CardContent>

			</Card>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/RomReviewView.js